import { NgTemplateOutlet } from '@angular/common';
import { Component, InputSignal, input, contentChildren } from '@angular/core';
import { SimplifiedListItemComponent } from './item/simplified-list-item.component';

@Component({
  selector: 'td-wb-simplified-list',
  templateUrl: './simplified-list.component.html',
  styleUrls: ['./simplified-list.component.scss'],
  imports: [
    NgTemplateOutlet
  ]
})
export class SimplifiedListComponent {
  readonly ariaLabel: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-label' });
  readonly ariaLabelledBy: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-labelledby' });
  readonly items = contentChildren(SimplifiedListItemComponent);
}
